<template>
	<div class="realTimeStatistics">
		<PageHeader @back="goback" :content="'实时统计'" />
		<div>
			<div class="realTimeTable">
				<el-table border :data="realTimeStatisticsData" style="width: 100%">
					<el-table-column align="center" fixed prop="userName" label="访员信息"></el-table-column>
					<el-table-column align="center" fixed label="状态">
						<template slot-scope="scope">
							<el-tag v-if="scope.row.loginState == 1" type="success">已登录</el-tag>
							<el-tag v-else type="info">未登录</el-tag>
							<!-- <span v-if="scope.row.loginState == 1" style="color:#67C23A ;">已登录</span>
							<span v-else style="color:#F56C6C;">未登录</span> -->
							<span class="logout" v-if="scope.row.loginState == 1" @click="logoutUser(scope.row)">注销</span>
						</template>
					</el-table-column>
					<el-table-column align="center" fixed prop="finishCount" label="完成数"></el-table-column>
					<el-table-column align="center" fixed label="成功率">
						<template slot-scope="scope">
							{{ scope.row.finishPercent }}%
						</template>
					</el-table-column>
					<el-table-column align="center" fixed label="约访">
						<template slot-scope="scope">
							<span>{{ scope.row.appointmentCount }}</span>
							<span class="assignment" v-if="scope.row.appointmentCount > 0" @click="appointmentUser(scope.row)">转让</span>
						</template>
					</el-table-column>
					<el-table-column align="center" fixed label="稍后">
						<template slot-scope="scope">
							<span>{{ scope.row.laterCount }}</span>
							<span class="later" v-if="scope.row.laterCount > 0" @click="recycleUser(scope.row)">回收</span>
						</template>
					</el-table-column>
				</el-table>
				<div class="block">
					<el-pagination
						background
						@size-change="realTimeStatisticsOnSizeChange"
						@current-change="realTimeStatisticsCurrentChange"
						:current-page="pagination.pageNo"
						:page-sizes="[5, 10, 50, 100, 200, 300, 400]"
						:page-size="pagination.pageSize"
						layout="total, sizes, prev, pager, next, jumper"
						:total="pagination.total"
					></el-pagination>
				</div>
			</div>

			<div class="BoxEcharts">
				<el-card shadow="never" class="ybStatistics">
					<div class="topTitle">
						<div class="title">样本统计</div>
						<div>
							<el-date-picker size="medium" value-format="yyyy-MM-dd HH:mm:ss" type="date" placeholder="选择日期" v-model="timeParams.beginTime" style="width: 150px;margin-right: 10px;"></el-date-picker>
							<el-date-picker size="medium" value-format="yyyy-MM-dd HH:mm:ss" type="date" placeholder="选择日期" v-model="timeParams.endTime" style="width: 150px;margin-right: 10px;"></el-date-picker>
							<el-button size="medium" @click="cx" type="primary">查询</el-button>
						</div>
						<div class="unit">单位(个)</div>
					</div>
					<div class="echart" ref="Lmain"></div>
				</el-card>
				<el-card shadow="never" class="finishDetails">
					<div class="singleDetails">
						<span class="title">总完成样本：</span>
						<span class="textVal">{{ formLabelAlign.total }} 个</span>
					</div>
					<!-- <div class="singleDetails">
						<span class="title">完成率：</span>
						<span class="textVal">{{ formLabelAlign.percent }}</span>
					</div> -->
					<div class="singleDetails">
						<span class="title">访问时长：</span>
						<span class="textVal">{{ formLabelAlign.totaltime || '--' }}</span>
					</div>
					<div class="singleDetails">
						<span class="title">平均访问时长：</span>
						<span class="textVal">{{ formLabelAlign.avgtime || '--' }}</span>
					</div>
				</el-card>
			</div>
		</div>

		<!-- 转让约访记录 -->
		<el-dialog title="选择转让访员" :visible.sync="userVisible" width="300px" :close-on-click-modal="false">
			<span>
				<el-select v-model="toUserName" placeholder="请选择" style="margin-left: 30px;">
					<el-option v-for="item in choiceInterviewer" :key="item.userId" :label="item.userName" :value="item.userId"></el-option>
				</el-select>
			</span>
			<span slot="footer" class="dialog-footer">
				<el-button size="medium" @click="userVisible = false">取 消</el-button>
				<el-button size="medium" type="primary" @click="appointmentUserOk">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
import echarts from 'echarts';
import PageHeader from '@/components/pageHeader.vue';
export default {
	components: {
		PageHeader
	},
	data() {
		return {
			makeOverUserId: '',
			toUserName: '',
			source: '',
			choiceInterviewer: [],
			userVisible: false,
			labelPosition: 'right',
			formLabelAlign: {
				avgtime: 0,
				percent: '',
				total: 0,
				totaltime: 0
			},
			timeParams: {
				beginTime: '',
				endTime: ''
			},
			surveyId: '',
			realTimeStatisticsData: [],
			pagination: {
				pageNo: 1,
				total: 0,
				pageSize: 10
			}
		};
	},
	computed: {
		selectIndex() {
			let state;
			if (this.$route.query.source == 'df') {
				state = 3;
			} else if (this.$route.query.source == 'mf') {
				state = 4;
			}
			return state;
		}
	},
	created() {
		this.surveyId = this.$route.query.id;
		this.source = this.$route.query.source;
		this.loadData();
		this.leftEcharts();
		this.queryFinishDetails();
	},
	methods: {
		recycleUser(scope) {
			this.$confirm('确定要回收吗, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			})
				.then(() => {
					let that = this;
					let params = {
						that: this,
						url: `${this.$config.service.resetUserLaterSample}`,
						method: 'POST',
						data: {
							surveyId: that.surveyId,
							userId: scope.interviewerId
						},
						cb(res) {
							if (res.code == 0) {
								that.loadData();
								that.$message.success(res.message);
							} else {
								that.$message.error(res.message);
							}
						}
					};
					this.$util.request(params);
				})
				.catch(() => {});
		},
		logoutUser(scope) {
			console.log(scope);
			this.$confirm('确定要注销该访员吗, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			})
				.then(() => {
					let that = this;
					let params = {
						that: this,
						url: `${this.$config.service.setUserLoginState}`,
						method: 'POST',
						data: {
							userId: scope.interviewerId
						},
						cb(res) {
							if (res.code == 0) {
								that.loadData();
								that.$message.success(res.message);
							} else {
								that.$message.error(res.message);
							}
						}
					};
					this.$util.request(params);
				})
				.catch(() => {});
		},
		appointmentUserOk() {
			if( this.toUserName == ''){
				this.$message.warning('请选择转让访员。');
				return false
			}
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.transferUserAppointmentSampleToOtherUser}`,
				method: 'POST',
				data: {
					surveyId: that.surveyId,
					userId: that.makeOverUserId,
					toUserName: that.toUserName,
				},
				cb(res) {
					console.log('leftEcharts', res.resultBody);
					if (res.code == 0) {
						that.userVisible = false;
						that.loadData();
						that.makeOverUserId = '';
						that.toUserName = '';
						that.$message.success(res.message);
					} else {
						that.choiceInterviewer = [];
						that.$message.error(res.message);
					}
				}
			};
			this.$util.request(params);
		},
		appointmentUser(scope) {
			console.log(scope);
			this.makeOverUserId = scope.interviewerId;
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.queryInterviewerSamleCount}`,
				method: 'POST',
				data: {
					surveyId: that.surveyId,
					source: that.source
				},
				cb(res) {
					console.log('leftEcharts', res.resultBody);
					if (res.code == 0) {
						that.choiceInterviewer = res.resultBody;
					} else {
						that.choiceInterviewer = [];
						that.$message.error(res.message);
					}
				}
			};
			this.$util.request(params);
			this.userVisible = true;
		},
		queryFinishDetails() {
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.queryFinishDetails}`,
				method: 'POST',
				data: {
					surveyId: that.surveyId,
					
				},
				cb(res) {
					console.log('leftEcharts', res.resultBody);
					if (res.code == 0) {
						that.formLabelAlign = res.resultBody;
					} else {
						that.formLabelAlign = {};
						that.$message.error(res.message);
					}
				}
			};
			this.$util.request(params);
		},
		cx() {
			this.leftEcharts();
		},
		leftEcharts() {
			let that = this;
			let data = [];
			let params = {
				that: this,
				url: `${this.$config.service.queryWJSampleStatisticsChart}`,
				method: 'POST',
				data: {
					surveyId: that.surveyId,
						source:that.source,
					beginTime: that.timeParams.beginTime,
					endExamTime: that.timeParams.endTime
				},
				cb(res) {
					console.log('leftEcharts', res.resultBody);
					if (res.code == 0) {
						data = res.resultBody;
						that.leftEchartsTwo(data);
					} else {
						that.$message.error(res.message);
					}
				}
			};
			this.$util.request(params);
		},
		leftEchartsTwo(data) {
			let xAxisData = [];
			let seriesData = [];
			data.forEach(item => {
				xAxisData.push(item.answerName);
				seriesData.push(item.number);
			});
			setTimeout(() => {
				let getchart = echarts.init(this.$refs.Lmain);
				let option = {
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							type: 'shadow'
						}
					},
					xAxis: {
						type: 'category',
						data: xAxisData
					},
					yAxis: {
						type: 'value'
					},
					series: [
						{
							data: seriesData,
							type: 'bar',
							barWidth: '20%'
						}
					],
					color: ['#0080ff', '#55acff', '#8ce0ff', '#898c9c', '#1f6588', '#18aeb7', '#f86d3f', '#dadde2']
				};
				getchart.clear();
				getchart.setOption(option);
				//随着屏幕大小调节图表
				window.addEventListener('resize', () => {
					getchart.resize();
				});
			}, 0);
		},

		loadData() {
			let data = {
				surveyId: this.surveyId,
				currentPage: this.pagination.pageNo,
				pageSize: this.pagination.pageSize,
				source:this.source
			};
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.queryAllUserSampleCount}`,
				method: 'POST',
				data: data,
				cb(res) {
					if (res.code == 0) {
						that.realTimeStatisticsData = res.resultBody.records;
						that.pagination.total = res.resultBody.total;
					} else {
						that.realTimeStatisticsData = [];
						that.pagination.total = 0;
						that.$message.error(res.message);
					}
				}
			};
			this.$util.request(params);
		},
		realTimeStatisticsOnSizeChange(val) {
			this.pagination.pageSize = val;
			this.pagination.pageNo = 1;
			this.loadData();
		},
		realTimeStatisticsCurrentChange(val) {
			this.pagination.pageNo = val;
			this.loadData();
		},
		goback() {
			this.$router.go(-1)
		}
	}
};
</script>

<style scoped lang="scss">
.realTimeStatistics {
	margin: 0px;
	padding: 0px;
	width: 100%;
	height: 100%;
	.details_header {
		// max-width: 1200px;
		height: 60px;
		line-height: 60px;
		text-align: center;
		background-color: #0080ff;
		margin: auto;
		display: flex;
		justify-content: space-between;
		span {
			// color: #333333;
			color: #fff;
			font-size: 16px;
			padding: 0px 30px;
		}
		margin-bottom: 20px;
		cursor: pointer;
	}
	.realTimeTable {
		padding: 20px;
		// margin-top: 20px;
		.logout {
			margin-left: 10px;
			cursor: pointer;
			// display: inline-block;
			// width: 57px;
			// height: 25px;
			// line-height: 25px;
			// border-radius: 34px;
			// background-color: rgba(112, 112, 112, 0.2);
			// text-align: center;
			color: #409eff;
		}
		.logout:hover{
			color: #66b1ff;
		}
		.assignment {
			margin-left: 10px;
			cursor: pointer;
			display: inline-block;
			width: 57px;
			height: 25px;
			line-height: 25px;
			border-radius: 34px;
			background-color: rgba(71, 199, 45, 0.2);
			text-align: center;
			color: #3fd321;
		}
		.later {
			margin-left: 10px;
			cursor: pointer;
			display: inline-block;
			width: 57px;
			height: 25px;
			line-height: 25px;
			border-radius: 34px;
			background-color: rgba(0, 136, 238, 0.2);
			text-align: center;
			color: #0088ee;
		}
		.block {
			text-align: right;
			margin-top: 20px;
		}
	}
	.BoxEcharts {
		// height: 446px;
		padding: 0 20px 20px 20px;
		display: flex;
		.ybStatistics {
			flex: 1;
			// background-color: #ffffff;
			margin-right: 20px;

			// width: 822px;
			// height: 414px;
			line-height: 20px;
			// background-color: rgba(255, 255, 255, 1);
			text-align: center;
			// box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.4);

			.topTitle {
				display: flex;
				justify-content: space-between;
				height: 40px;
				line-height: 40px;
				margin: 10px 20px 0px 20px;
				position: relative;
				.title {
					font-family: SourceHanSansSC;
					font-weight: 400;
					font-size: 18px;
					color: rgba(16, 16, 16, 0.8);
					font-style: normal;
					letter-spacing: 0px;
					line-height: 40px;
					text-decoration: none;
				}
				.unit {
					position: absolute;
					right: 0px;
					top: 60px;
					font-size: 14px;
					color: rgba(16, 16, 16, 0.6);
					font-style: normal;
					letter-spacing: 0px;
					line-height: 20px;
					text-decoration: none;
				}
			}

			.echart {
				width: 90%;
				height: 400px;
				margin: 20px auto;
			}
		}
		.finishDetails {
			width: 395px;
			// height: 414px;
			line-height: 20px;
			// background-color: rgba(255, 255, 255, 1);
			text-align: center;
			// box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.4);
			display: flex;
			flex-direction: column;
			justify-content: center;
			.singleDetails {
				display: flex;
				justify-content: center;
				// width: 300px;
				height: 50px;
				line-height: 50px;
				// margin: 0px auto;
				.title {
					width: 120px;
					text-align: right;
				}
				.textVal {
					width: 100px;
				}
			}
		}
	}
}
</style>
